import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Button';
import { ErrorState } from '@/components/ErrorState';
import { Spinner } from '@/components/LoadingState';

import { AttestationViewer } from '@/features/attestations/AttestationViewer';
import { useGiDetail } from '@/hooks/useVault';

export function AttestationsPage() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation(['attestations', 'errors']);
  const query = useGiDetail(id);

  if (query.isPending) {
    return (
      <div className="flex h-40 items-center justify-center">
        <Spinner size="md" />
      </div>
    );
  }
  if (query.isError || !query.data) {
    return (
      <div className="mx-auto max-w-2xl">
        <ErrorState
          title={t('not_found.title', { ns: 'errors' })}
          body={t('not_found.body', { ns: 'errors' })}
          actions={
            <Link to="/" className="contents">
              <Button variant="secondary" size="sm">
                {t('back')}
              </Button>
            </Link>
          }
        />
      </div>
    );
  }

  const { manifest } = query.data;

  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-6">
      <Link to={`/gi/${manifest.root_id}`} className="text-sm text-ink-muted hover:text-ink">
        {t('back')}
      </Link>
      <header>
        <h1 className="text-2xl font-semibold tracking-tight text-ink">{manifest.name}</h1>
        <p className="mt-1 text-sm text-ink-muted">{t('subtitle')}</p>
      </header>
      <AttestationViewer root_id={manifest.root_id} gi_name={manifest.name} />
    </div>
  );
}
